import React, { useState } from 'react';
import './SpecialGiftSequence.css';

const GIFTS = [
  { id: 1, title: 'Star Certificate', file: '/pdf/Star%20Certificate%20136864%20D.pdf', icon: '⭐' },
  { id: 2, title: 'Super Star Poster', file: '/pdf/SuperStarPoster%20136864%20D.pdf', icon: '🌠' },
  { id: 3, title: 'Star Locator Guide', file: '/pdf/How%20to%20locate%20your%20star%20Guide.pdf', icon: '🗺️' },
  { id: 4, title: 'Cancer Constellation', file: '/pdf/CONSTELLATION%20-%20CANCER.pdf', icon: '♋' }
];

export default function SpecialGiftSequence({ onClose }) {
  // phases: 'video' -> 'envelope' -> 'gifts'
  const [phase, setPhase] = useState('video');
  const [isFlapOpen, setIsFlapOpen] = useState(false);

  const handleVideoEnd = () => {
    // When video finishes, transition to envelope
    setPhase('envelope');
  };

  const handleEnvelopeClick = () => {
    if (isFlapOpen) return;
    setIsFlapOpen(true);
    // Wait for the envelope animation to finish, then show the gifts
    setTimeout(() => {
      setPhase('gifts');
    }, 2000); // 2 seconds for animation
  };

  return (
    <div className="sgs-container">
      <button className="sgs-close-btn" onClick={onClose} aria-label="Close">✕</button>

      {/* PHASE 1: VIDEO */}
      {phase === 'video' && (
        <div className="sgs-video-phase">
          <div className="sgs-video-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px', width: '100%', maxWidth: '600px', margin: '0 auto' }}>
            <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
              <iframe 
                src="https://www.youtube.com/embed/eTGeV4_1A0o?autoplay=1&rel=0" 
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '12px', boxShadow: '0 10px 40px rgba(0,0,0,0.5)' }}
              ></iframe>
            </div>
            <button 
              onClick={handleVideoEnd}
              style={{
                background: 'linear-gradient(135deg, #a8d8ea, #f5c2d0)',
                color: 'white', border: 'none', padding: '12px 28px', borderRadius: '30px',
                fontSize: '1.1rem', fontWeight: 'bold', cursor: 'pointer',
                boxShadow: '0 8px 24px rgba(245, 194, 208, 0.4)',
                letterSpacing: '0.05em'
              }}
            >
              Continue ➔
            </button>
          </div>
        </div>
      )}

      {/* PHASE 2: THE ENVELOPE */}
      {phase === 'envelope' && (
        <div className="sgs-envelope-phase">
          <h2 className="sgs-envelope-title">Wait, there is one more thing...</h2>
          <div className={`sgs-envelope-wrapper ${isFlapOpen ? 'is-open' : ''}`} onClick={handleEnvelopeClick}>
            <div className="sgs-envelope">
              <div className="sgs-envelope-flap"></div>
              <div className="sgs-envelope-letter">
                <p>Digital<br/>Gifts</p>
              </div>
              <div className="sgs-envelope-body">
                <div className="sgs-envelope-front"></div>
              </div>
              <div className={`sgs-wax-seal ${isFlapOpen ? 'seal-break' : ''}`}>
                <span>&#x2764;</span>
              </div>
            </div>
          </div>
          <p style={{color: 'rgba(255,255,255,0.7)', letterSpacing: '0.1em'}}>Tap to open</p>
        </div>
      )}

      {/* PHASE 3: THE 4 GIFTS */}
      {phase === 'gifts' && (
        <div className="sgs-gifts-phase">
          <h1 className="sgs-gifts-title">For You, Forever</h1>
          <p className="sgs-gifts-sub">Four special gifts crafted with endless love.</p>
          
          <div className="gifts-grid">
            {GIFTS.map(gift => (
              <a key={gift.id} href={gift.file} target="_blank" rel="noreferrer" className="gift-card">
                <span className="gift-icon">{gift.icon}</span>
                <h3 className="gift-title">{gift.title}</h3>
                <button className="gift-btn">Open Gift</button>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
